import React, { cloneElement } from 'react';

import { cn } from 'helpers/classnames';

import css from 'styles/components/account/returns/timeline.scss';

const TimelineItem = ({ color = 'blue', dot, className, children, ...restProps }) => {
  const itemClassName = cn(css.timelineItem, 'zappos:body-s', className);
  const colorClass = {
    blue: css['timelineHead-blue'],
    green: css['timelineHead-green'],
    gray: css['timelineHead-gray'],
    red: css['timelineHead-red']
  };
  const dotClassName = cn(css.timelineHead, colorClass[color], {
    [css.timeLineCustom]: !!dot
  });
  const customColor = /blue|red|green|gray/.test(color || '') ? undefined : color;
  return (
    <li {...restProps} className={itemClassName}>
      <div className={css.timelineTail} />
      <div className={dotClassName} style={{ borderColor: customColor, color: customColor }}>
        {dot}
      </div>
      <div className={css.timelineContent}>{children}</div>
    </li>
  );
};

const Timeline = ({ children, className, ...restProps }) => {
  const timeLineItems = React.Children.toArray(children);
  const truthyItems = timeLineItems.filter(item => !!item);
  const itemsCount = React.Children.count(truthyItems);
  const items = React.Children.map(truthyItems, (ele, idx) => {
    const positionClass = idx === itemsCount - 1 ? css.timelineItemLast : '';
    return cloneElement(ele, {
      className: cn(ele.props.className, positionClass)
    });
  });
  const classString = cn(css.timeline, 'zappos:body-s', className);
  return (
    <ul {...restProps} className={classString}>
      {items}
    </ul>
  );
};

Timeline.TimelineItem = TimelineItem;

export default Timeline;
